import Service from "../../Services";

const MainPage = {
  namespaced : true,
  state : {
    form : {
      is_publish : true,
      name_th : '',
      name_en : '',
      description_en : '',
      description_th : '',
      video_url : '',
      slide_images: []
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        is_publish : true,
        name_th : '',
        name_en : '',
        description_en : '',
        description_th : '',
        video_url : '',
        slide_images: []
      }
    },
    SET_SLIDE_IMAGE: (state, data) => {
      state.form.slide_images = [
        ...state.form.slide_images,
        {
          ...data
        }
      ];
    },
    REMOVE_SLIDE_IMAGE: (state, index) => {
      state.form.slide_images = state.form.slide_images.filter(
          (detail, itemIndex) => index !== itemIndex
      );
    }
  },
  actions : {
    showMainPage({commit},id){
      return Service.MainPageAPI.showMainPage(id);
    },
    saveMainPage({commit},{id,data}){
      if(id){
        return Service.MainPageAPI.updateMainPage(id,data);
      }
    },
    setFormFreePage({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    },
    insertSlideImage({ commit }, data) {
      commit("SET_SLIDE_IMAGE", data);
    },
    removeSlideImage({ commit }, index) {
      commit("REMOVE_SLIDE_IMAGE", index);
    }
  },
}
export default MainPage
